<template>
  <div class="flex flex-1 flex-col justify-between p-5">
    <h2>Parcours en pause</h2>
    {{ step.delay_message }}
  </div>
  <div class="flex flex-row justify-end items-center gap-x-3">
    <PathwayDelayLabel @on-skip-delay="$emit('skipDelay')" />
  </div>
</template>

<script lang="ts" setup>
import {Pathway, PathwayStep} from "@/program/interfaces/Program";
import PathwayDelayLabel from "@/pathway/components/PathwayDelayLabel.vue";

defineProps<{
    pathway: Pathway;
    step: PathwayStep;
    consumerKey: string;
}>();

defineEmits(['skipDelay']);
</script>
